import { Component } from '@angular/core';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ActivatedRoute, RouterModule } from '@angular/router';
import { UtilService } from '@shared/services/util.service';
import { Subject, takeUntil } from 'rxjs';
import { SidenavComponent } from '../sidenav/sidenav.component';
import { ToolbarComponent } from '../toolbar/toolbar.component';
import { AdministrarTiendaService } from '@core/services/tienda/administrar-tienda.service';
import { DeviceService } from '@core/services/device.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-tienda-layout',
  standalone: true,
  imports: [
    CommonModule,
    RouterModule,
    MatSidenavModule,
    SidenavComponent,
    ToolbarComponent,
    
  ],
  templateUrl: './tienda-layout.component.html',
  styleUrl: './tienda-layout.component.scss'
})
export class TiendaLayoutComponent {
title = 'polizas';
  opened = true;
  idTienda: string = "";
  private destroy$ = new Subject<void>();
  isMobile : boolean = false;

  constructor(
    private utilSvc: UtilService, 
    private activatedRoute: ActivatedRoute,
    private administrarTienda: AdministrarTiendaService,
    private deviceService: DeviceService
  ) {
    this.activatedRoute.paramMap.subscribe((params) => {
      this.idTienda = params.get('idTienda') || ''; // Asigna el valor del parámetro
      this.administrarTienda.idTienda = this.idTienda;
    });
  }

  ngOnInit(): void {
     this.deviceService.isMobile$.subscribe(value => {
      this.isMobile = value
    });
    this.utilSvc.sidenavOpen$.pipe(takeUntil(this.destroy$)).subscribe((sidenav) => {
      this.opened = sidenav;
    });
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
